import styled from "styled-components";
import { Box, Button, Image, Text } from "rebass/styled-components";
import { FaApple } from "react-icons/fa";
import { ImAndroid } from "react-icons/im";

export const StyledMobileAppPromo = styled(Box)`
  flex-shrink: 0;
  margin-top: auto;
  width: 100%;
`;

export const AppButton = styled(Button)`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy100};
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  flex: 1;
  gap: 8px;
  justify-content: center;
  min-height: 30px;
  padding: 0;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.navy50};
    border-color: ${({ theme }) => theme.colors.envy};
    cursor: pointer;

    > * {
      color: ${({ theme }) => theme.colors.envy};
    }
  }
`;

export const AppButtonText = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 12px;
  font-weight: 500;
`;

export const StyledAppleIcon = styled(FaApple)`
  color: ${({ theme }) => theme.colors.chalk};
  height: 16px;
  margin-top: -4px;
  width: 16px;
`;

export const StyledGooglePlayIcon = styled(ImAndroid)`
  color: ${({ theme }) => theme.colors.chalk};
  height: 16px;
  width: 16px;
`;

export const MobileLogo = styled(Image)`
  height: 40px;
  object-fit: contain;
  width: 40px;
`;
